var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSvg5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flexibility (1) 1",
    clipPath: "url(#clip0_280_566)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17 24.0391C18.6504 24.0391 19.9883 22.7012 19.9883 21.0508C19.9883 19.4004 18.6504 18.0625 17 18.0625C15.3496 18.0625 14.0117 19.4004 14.0117 21.0508C14.0117 22.7012 15.3496 24.0391 17 24.0391Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17 24.0391C14.2539 24.0391 12.0195 26.2734 12.0195 29.0195V34H21.9805V29.0195C21.9805 26.2734 19.7461 24.0391 17 24.0391Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M33.9999 13.0822L25.9648 7.24512V11.09H22.9765C20.8357 11.09 18.6776 11.9528 16.9951 13.7748C16.3361 14.5351 15.8358 15.4029 15.4989 16.3271C15.9756 16.175 16.4735 16.0705 16.9999 16.0705C17.9802 16.0705 18.8891 16.3649 19.6606 16.856C20.3754 15.7836 21.5935 15.0744 22.9765 15.0744H25.9648V18.9193L33.9999 13.0822Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.0078 9.93836C15.3571 10.0917 15.7016 10.2569 16.0311 10.4508C16.3617 10.6324 16.6843 10.8707 17.0054 11.1108C17.3447 10.8556 17.6846 10.6086 18.033 10.4167C18.342 10.2395 18.6658 10.0901 18.9921 9.94719V8.10156H22.837L17 0L11.1628 8.10156H15.0078V9.93836Z",
    fill: "#00FFF0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M13.5072 15.9758L13.6275 15.6454C14.0532 14.476 14.6779 13.4118 15.4826 12.4809C14.2039 11.6321 12.8335 11.09 11.0234 11.09H8.03516V7.24512L0 13.0822L8.03516 18.9193V15.0744H11.0234C11.9687 15.0744 12.8236 15.4235 13.5072 15.9758Z",
    fill: "#00FFF0"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_280_566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg5);
export default __webpack_public_path__ + "static/media/svg5.a1cb4e08609d19e71d35aa70d07542a2.svg";
export { ForwardRef as ReactComponent };